import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"

import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import Select from "react-select"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"

const NewAsset = props => {

  const history = useHistory();

  const [assetCode, setAssetCode] = React.useState('');
  const [assetName, setAssetName] = React.useState('');
  const [assetStatus, setAssetStatus] = React.useState(undefined);
  const [assetOwner, setAssetOwner] = React.useState(undefined);
  const [parentAssetCode, setParentAssetCode] = React.useState('');
  const [assetType, setAssetType] = React.useState(null);
  const [assetCategory, setAssetCategory] = React.useState(undefined);

  // const [property, setProperty] = React.useState(undefined);
  // const [block, setBlock] = React.useState(undefined);
  const [building, setBuilding] = React.useState(null);
  const [floor, setFloor] = React.useState(null);
  const [room, setRoom] = React.useState(null);

  const [critical, setCritical] = React.useState(undefined);
  const [capacity, setCapacity] = React.useState('');
  const [make, setMake] = React.useState('');
  const [assetSerialNo, setAssetSerialNo] = React.useState('');
  const [compassAlertCode, setCompassAlertCode] = React.useState('');
  const [warrantyValidDate, setWarrantyValidDate] = React.useState('');
  const [maintenancePolicy, setMaintenancePolicy] = React.useState(undefined);
  const [measurementUnit, setMeasurementUnit] = React.useState(undefined);
  const [modelNumber, setModelNumber] = React.useState('');
  const [serviceType, setServiceType] = React.useState(undefined);
  const [form, setForm] = React.useState(null);
  const [clientAssetCode, setClientAssetCode] = React.useState('');
  const [warrantyApplicable, setWarrantyApplicable] = React.useState(undefined);
  const [dateOfInstallation, setDateOfInstallation] = React.useState('');
  const [remarks, setRemarks] = React.useState('');
  
  const [assetTypes, setAssetTypes] = React.useState([]);
  const [assetCategories, setAssetCategories] = React.useState([]);

  // const [properties, setProperties] = React.useState([]);
  // const [blocks, setBlocks] = React.useState([]);
  const [buildings, setBuildings] = React.useState([]);
  const [floors, setFloors] = React.useState([]);
  const [rooms, setRooms] = React.useState([]);
  const [serviceTypes, setServiceTypes] = React.useState([]);
  const [forms, setForms] = React.useState([]);

  const [initializing, setInitializing] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [validationRun, setValidationRun] = React.useState(false);
  const [errors, setErrors] = React.useState([]);


  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_ASSET+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        // setName(response.data.name);
        // setProperty({value: response.data.property.id, label: response.data.property.name});

        // console.log('EDITTHIS', response.data, response.data.company);

        if(response.data) {

          setAssetCode(response.data.asset_code);
          setAssetName(response.data.name);
          setAssetStatus(response.data.asset_status == null ? undefined : response.data.asset_status);
          setAssetOwner(response.data.owner == null ? undefined : response.data.owner);
          setParentAssetCode(response.data.parent_asset_code);
          setAssetType(response.data.assettype == null ? null : {value: response.data.assettype.id, label: response.data.assettype.name});
          setAssetCategory(response.data.assetcategory == null ? null : {value: response.data.assetcategory.id, label: response.data.assetcategory.name});
          // setProperty(response.data.property == null ? null : {value: response.data.property.id, label: response.data.property.name});
          // setBlock(response.data.block == null ? null : {value: response.data.block.id, label: response.data.block.name});
          setBuilding(response.data.building == null ? null : {value: response.data.building.id, label: response.data.building.name});
          setFloor(response.data.floor == null ? null : {value: response.data.floor.id, label: response.data.floor.name});
          setRoom(response.data.room == null ? null : {value: response.data.room.id, label: response.data.room.name});
          setForm(response.data.form == null ? null : {value: response.data.form.id, label: response.data.form.name});
          setCritical(response.data.critical == null ? undefined : response.data.critical);
          setCapacity(response.data.capacity);
          setMake(response.data.make);
          setAssetSerialNo(response.data.asset_serial_no);
          setCompassAlertCode(response.data.compass_alert_code);
          setWarrantyValidDate(response.data.warranty_valid_date == null ? undefined : response.data.warranty_valid_date.split(' ')[0]);
          setMaintenancePolicy(response.data.maintenance_policy == null ? undefined : response.data.maintenance_policy);
          setMeasurementUnit(response.data.measurement_unit == null ? undefined : response.data.measurement_unit);
          setModelNumber(response.data.model);
          setServiceType(response.data.servicetype_id == null ? undefined : response.data.servicetype_id);
          setClientAssetCode(response.data.client_asset_code);
          setWarrantyApplicable(response.data.warranty_applicable == null ? undefined : response.data.warranty_applicable);
          setDateOfInstallation(response.data.date_of_installation == null ? undefined : response.data.date_of_installation.split(' ')[0]);
          setRemarks(response.data.remarks);
        }
        else {
          cogoToast.error('Could not fetch asset data');
        }

        // setProperty(response.data.property_id == null ? 'null' : response.data.property_id);
        // setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch asset data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const init = () => {
    setInitializing(true);
      get(url.GET_NEW_ASSET+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setAssetTypes(response.data.assettypes);
        setAssetCategories(response.data.assetcategories);
        // setProperties(response.data.properties);
        // setBlocks(response.data.blocks);
        setBuildings(response.data.buildings);
        setFloors(response.data.floors);
        setRooms(response.data.rooms);
        setForms(response.data.forms);
        setServiceTypes(response.data.servicetypes)
        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });

  }

  React.useEffect(()=>{
    if(props.filterBlock) {
      setRoom(null);
      setFloor(null);
      setBuilding(null);
      setAssetType(null);
      setForm(null);
      init();
    }
  }, [props.filterBlock]);

  React.useEffect(() => {
    if(props.match.params.id && props.match.params.id !== 'new') {
    fetchData(props.match.params.id);
    }
  }, []);



  const handleSubmit = () => {

    if((assetName.trim() == '') || (assetCode.trim() == '') || (assetStatus == undefined)) {
      setValidationRun(true);
      cogoToast.error('Please fill all the required fields');
      return;
    }
    
    if(assetType === null) {
      cogoToast.error('Asset type is required');
      return;
    }
    
    if((building === null) || (floor === null) || (room === null)) {
      cogoToast.error('Location details are required');
      return;
    }

    // return; 

    // if(activityName == '') {
    //   cogoToast.error('Activity name is required');
    //   return;
    // }


    let data = {
      'id': props.match.params.id ? props.match.params.id : 'new',
      'name': assetName,
      'property_id': props.filterProperty.id,
      'block_id': props.filterBlock.id,
      'building_id': building == null ? null : building.value,
      'floor_id': floor == null ? null : floor.value,
      'room_id': room == null ? null : room.value,
      'form_id': form == null ? null : form.value,
      'asset_code': assetCode,
      'owner': assetOwner == undefined ? null : assetOwner,
      'make': make,
      'model': modelNumber,
      'parent_asset_code': parentAssetCode,
      'critical': critical == undefined ? 'No' : critical,
      'capacity': capacity,
      'asset_serial_no': assetSerialNo,
      'compass_alert_code': compassAlertCode,
      'assettype_id': assetType == null ? null : assetType.value,
      'assetcategory_id': assetCategory == null ? null : assetCategory.value,
      'asset_status': assetStatus == undefined ? null : assetStatus,
      'warranty_applicable': warrantyApplicable == undefined ? 'No' : warrantyApplicable,
      'warranty_valid_date': warrantyValidDate,
      'date_of_installation': dateOfInstallation,
      'remarks': remarks,
      'maintenance_policy': maintenancePolicy == undefined ? null : maintenancePolicy,
      'measurement_unit': measurementUnit == undefined ? null : measurementUnit,
      'servicetype_id': serviceType == undefined ? null : serviceType,
      'client_asset_code': clientAssetCode,
    };

    console.log('data', data);
    // return;

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_ASSET, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/assets/index');
        cogoToast.success('Asset '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
      // if(response == true) {
      // }
      // if(response.status == 200) {
      //   if(response.data == 'input') {
      //     cogoToast.error('Please check your input');
      //     setLoading(false);
      //   }
      //   else if(response.data == 'exists') {
      //     cogoToast.error('Beacon name is already taken');
      //     setLoading(false);
      //   }
      //   else {
      //     props.insertItem(response.data);
      //   }
      // }
      // else {
      //   cogoToast.error('Beacon could not be created');
      //   setLoading(false);
      // }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  // const dispBlocks = property == undefined ? [] : blocks.filter(b => b.property_id == property?.value);
  // const dispBuildings = block == undefined ? [] : buildings.filter(b => b.block_id == block?.value);
  const dispFloors = building == undefined ? [] : floors.filter(b => b.building_id == building?.value);
  const dispRooms = floor == undefined ? [] : rooms.filter(b => b.floor_id == floor?.value);


  // console.log(serviceType);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add New Asset | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} Asset</h3>
            <Link className="btn btn-secondary" to="/assets/index">Back</Link>
          </div>

          <Card>
            <CardBody>
              <CardTitle tag="h3">BASIC DETAILS</CardTitle>
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-4">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Asset Code</label>
                    <div className="col-sm-9">
                      <input type="text" autoFocus className={"form-control "+((validationRun && (assetCode.trim() == '')) ? "border-danger" : "")} id="assetCode" value={assetCode} onChange={(e)=>{ setAssetCode(e.target.value); }} />
                      {/* <input type="text" readOnly className="form-control-plaintext" id="assetCode" value="EPUNEETZ Pune000146" /> */}
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="assetName" className="col-sm-3 col-form-label label-required">Asset Name</label>
                    <div className="col-sm-9">
                      <input type="text" className={"form-control "+((validationRun && (assetName.trim() == '')) ? "border-danger" : "")} id="assetName" value={assetName} onChange={(e)=>{ setAssetName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="assetStatus" className="col-sm-3 col-form-label label-required">Asset Status</label>
                    <div className="col-sm-9">
                      <select className={"form-control "+((validationRun && (assetStatus == undefined)) ? "border-danger" : "")} placeholder="Select"
                        value={assetStatus}
                        onChange={(e) => { setAssetStatus(e.target.value); }}
                      >
                        <option value={undefined}>Select one</option>
                        <option value="Working">Working</option>
                        <option value="Stand By">Stand By</option>
                        <option value="Under Maintenance">Under Maintenance</option>
                        <option value="Monthly">Remove From Scope</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="assetForm" className="col-sm-3 col-form-label label-required">Maintenance Form</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one"
                        id="assetForm"
                        title="Asset Form"
                        options={forms}
                        value={form}
                        onChange={e=>{
                          setForm(e);
                        }}
                        />
                    </div>
                  </div>


                </div>
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="assetOwner" className="col-sm-3 col-form-label">Asset Owner</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select"
                        value={assetOwner}
                        onChange={(e) => { setAssetOwner(e.target.value); }}
                      >
                        <option value={undefined}>Select one</option>
                        <option value="Compass">Compass</option>
                        <option value="Client">Client</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="parentAssetCode" className="col-sm-3 col-form-label">Parent Asset Code</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="parentAssetCode" value={parentAssetCode} onChange={(e)=>{ setParentAssetCode(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="assetTypeSelect" className="col-sm-3 col-form-label label-required">Asset Type</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one"
                        id="assetTypeSelect"
                        title="assetType"
                        options={assetTypes}
                        value={assetType}
                        onChange={e=>{
                          setAssetType(e);
                        }}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>

<Card>
  <CardBody>
    <CardTitle tag="h3">LOCATION DETAILS</CardTitle>
    {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
    <div className="row mt-4">
      <div className="col">
        {/* <div className="mb-4 row">
          <label htmlFor="propertySelect" className="col-sm-3 col-form-label">Property</label>
          <div className="col-sm-9">
            <Select
              classNamePrefix="select2-selection"
              placeholder="Select one"
              id="propertySelect"
              title="Property"
              options={properties}
              value={property}
              onChange={e=>{
                setBlock(null);
                setBuilding(null);
                setFloor(null);
                setRoom(null);
                setProperty(e);
              }}
              />
          </div>
        </div> */}
        <div className="mb-4 row">
          <label htmlFor="buildingSelect" className="col-sm-3 col-form-label label-required">Building</label>
          <div className="col-sm-9">
            <Select
              classNamePrefix="select2-selection"
              placeholder="Select one"
              id="buildingSelect"
              title="building"
              options={buildings}
              value={building}
              onChange={e=>{
                setFloor(null);
                setRoom(null);
                setBuilding(e);
              }}
              />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="roomSelect" className="col-sm-3 col-form-label label-required">Room</label>
          <div className="col-sm-9">
            <Select
              classNamePrefix="select2-selection"
              placeholder="Select one"
              id="roomSelect"
              title="room"
              options={dispRooms}
              value={room}
              onChange={e=>{
                setRoom(e);
              }}
              />
          </div>
        </div>





      </div>
      <div className="col">
        {/* <div className="mb-4 row">
          <label htmlFor="blockSelect" className="col-sm-3 col-form-label">Block</label>
          <div className="col-sm-9">
            <Select
              classNamePrefix="select2-selection"
              placeholder="Select one"
              id="blockSelect"
              title="block"
              options={dispBlocks}
              value={block}
              onChange={e=>{
                setBuilding(null);
                setFloor(null);
                setRoom(null);
                setBlock(e);
              }}
              />
          </div>
        </div> */}

        <div className="mb-4 row">
          <label htmlFor="floorSelect" className="col-sm-3 col-form-label label-required">Floor</label>
          <div className="col-sm-9">
            <Select
              classNamePrefix="select2-selection"
              placeholder="Select one"
              id="floorSelect"
              title="floor"
              options={dispFloors}
              value={floor}
              onChange={e=>{
                setRoom(null);
                setFloor(e);
              }}
              />
          </div>
        </div>
      </div>
    </div>
  </CardBody>
</Card>

<Card>
  <CardBody>
    <CardTitle tag="h3">ASSET DETAILS</CardTitle>
    {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
    <div className="row mt-4">
      <div className="col">
        <div className="mb-4 row">
          <label htmlFor="critical" className="col-sm-3 col-form-label">Critical</label>
          <div className="col-sm-9">
            <select className="form-control" placeholder="Select"
              value={critical}
              onChange={(e) => { setCritical(e.target.value); }}
            >
              <option value={undefined}>Select one</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="capacity" className="col-sm-3 col-form-label">Capacity</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="capacity" value={capacity} onChange={(e)=>{ setCapacity(e.target.value); }} />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="make" className="col-sm-3 col-form-label">Make</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="make" value={make} onChange={(e)=>{ setMake(e.target.value); }} />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="assetSerialNo" className="col-sm-3 col-form-label">Asset Serial No</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="assetSerialNo" value={assetSerialNo} onChange={(e)=>{ setAssetSerialNo(e.target.value); }} />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="assetCategorySelect" className="col-sm-3 col-form-label">Asset Category</label>
          <div className="col-sm-9">
            <Select
              classNamePrefix="select2-selection"
              placeholder="Select one"
              id="assetCategorySelect"
              title="assetCategory"
              options={assetCategories}
              value={assetCategory}
              onChange={e=>{
                setAssetCategory(e);
              }}
              />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="compassAlertCode" className="col-sm-3 col-form-label">Compass Alert Code</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="compassAlertCode" value={compassAlertCode} onChange={(e)=>{ setCompassAlertCode(e.target.value); }} />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="warrantyValidDate" className="col-sm-3 col-form-label">Warranty Valid Date</label>
          <div className="col-sm-9">
          <input type="text" className="form-control" id="warrantyValidDate"
              type="date"
              disabled={warrantyApplicable !== 'Yes'}
              // defaultValue="2019-08-19"
              value={warrantyValidDate} onChange={e => { setWarrantyValidDate(e.target.value); }}
            />
          </div>
        </div>
      </div>
      <div className="col">
        <div className="mb-4 row">
          <label htmlFor="maintenancePolicy" className="col-sm-3 col-form-label">Maintenance Policy</label>
          <div className="col-sm-9">
            <select className="form-control" id="maintenancePolicy" placeholder="Select"
              value={maintenancePolicy}
              onChange={(e) => { setMaintenancePolicy(e.target.value); }}
            >
              <option value={undefined}>Select one</option>
              <option value="NA">Not Applicable</option>
              <option value="Schedule Planned">Schedule Planned</option>
              <option value="Predictive">Predictive</option>
              <option value="Shutdown">Shutdown</option>
              <option value="Breakdown">Breakdown</option>
            </select>
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="measurementUnit" className="col-sm-3 col-form-label">Measurement Unit</label>
          <div className="col-sm-9">
            <select className="form-control" id="measurementUnit" placeholder="Select"
              value={measurementUnit}
              onChange={(e) => { setMeasurementUnit(e.target.value); }}
            >
              <option value={undefined}>Select one</option>
              <option value="M3 /hr">M3 /hr</option>
              <option value="100 LTR">100 LTR</option>
              <option value="CFM">CFM</option>
              <option value="NOT AVAILABLE">NOT AVAILABLE</option>
              <option value="AMP">AMP</option>
              <option value="kVR">kVR</option>
              <option value="KW/HP">KW/HP</option>
              <option value="KVAR">KVAR</option>
              <option value="AH">AH</option>
              <option value="BHP">BHP</option>
              <option value="Sq Feet">Sq Feet</option>
              <option value="Meter">Meter</option>
              <option value="KM">KM</option>
              <option value="Foot">Foot</option>
              <option value="Ton">Ton</option>
              <option value="KVA">KVA</option>
              <option value="BAR">BAR</option>
              <option value="KW">KW</option>
              <option value="Liters">Liters</option>
              <option value="KL">KL</option>
              <option value="Amps">Amps</option>
              <option value="Volts">Volts</option>
              <option value="Nos">Nos</option>
              <option value="HP">HP</option>
              <option value="CUM">CUM</option>
              <option value="GPM">GPM</option>
              <option value="NA">NA</option>
              <option value="Kgs">Kgs</option>
              <option value="TR">TR</option>
              <option value="Ton Refrigrent">Ton Refrigrent</option>
              <option value="A">A</option>
              <option value="Persons/KG">Persons/KG</option>
              <option value="KVA,AMP">KVA,AMP</option>
              <option value="W">W</option>
              <option value="M">M</option>
              <option value="KA/AMP">KA/AMP</option>
              <option value="KG/KW">KG/KW</option>
              <option value="LTR">LTR</option>
              <option value="CFM/KW">CFM/KW</option>
              <option value="CFM/KW/HP">CFM/KW/HP</option>
              <option value="KG">KG</option>
              <option value="VA">VA</option>
              <option value="L">L</option>
              <option value="LTR">LTR.</option>
              <option value="m3/hr">m3/hr</option>
              <option value="M³/hrs( Max ">M³/hrs( Max )</option>
              <option value="CUM/Hr">CUM/Hr</option>
              <option value="LPH">LPH</option>
              <option value="M³/hrs">M³/hrs</option>
              <option value="kn,Single Suspension">kn,Single Suspension</option>
              <option value="CMF/KW">CMF/KW</option>
              <option value="CMF/KW/HP">CMF/KW/HP</option>
              <option value="RPM">RPM</option>
            </select>
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="modelNumber" className="col-sm-3 col-form-label">Model Number</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="modelNumber" value={modelNumber} onChange={(e)=>{ setModelNumber(e.target.value); }} />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="serviceType" className="col-sm-3 col-form-label">Service Type</label>
          <div className="col-sm-9">
            <select className="form-control" id="serviceType" placeholder="Select"
              value={serviceType}
              onChange={(e) => { setServiceType(e.target.value); }}
            >
              <option value={undefined}>Select one</option>
              { serviceTypes.map((sType, sTypeIdx)=>(
                <option key={sTypeIdx} value={sType.value}>{sType.label}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="clientAssetCode" className="col-sm-3 col-form-label">Client Asset Code</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="clientAssetCode" value={clientAssetCode} onChange={(e)=>{ setClientAssetCode(e.target.value); }} />
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="warrantyApplicableDate" className="col-sm-3 col-form-label">Warranty Applicable</label>
          <div className="col-sm-9">
            <select className="form-control" placeholder="Select"
              value={warrantyApplicable}
              onChange={(e) => { setWarrantyApplicable(e.target.value); }}
            >
              <option value={undefined}>Select one</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
        <div className="mb-4 row">
          <label htmlFor="dateOfInstallation" className="col-sm-3 col-form-label">Date of Installation</label>
          <div className="col-sm-9">
            <input type="text" className="form-control" id="dateOfInstallationDate"
              type="date"
              // defaultValue="2019-08-19"
              value={dateOfInstallation} onChange={e => { setDateOfInstallation(e.target.value); }}
            />
          </div>
        </div>
      </div>
    </div>

    <div className="mb-4 container">
      <div className="row">
        <label htmlFor="remarks" className="col-sm-1 col-form-label">Remarks</label>
        <div className="col-sm-11">
          <input type="text" className="form-control" id="remarks" value={remarks} onChange={(e)=>{ setRemarks(e.target.value); }} />
        </div>
      </div>
    </div>


    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={() => { handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/assets/index">Cancel</Link>
      </div>
    </div>
  </CardBody>
</Card>

        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewAsset)